import React from 'react';
import PropTypes from 'prop-types';

const AuthAlert = ({alert}) => (
    <div className={`c-alert u-m-zero c-alert-- alert u-mb-medium`}>
        <div className="c-alert__content">
            <h4 className="c-alert__title">{alert.subject}</h4>
            <p>{alert.message}</p>
        </div>

        <button className="c-close" data-dismiss="alert" type="button">
            ×
        </button>
    </div>
);

AuthAlert.propTypes = {
    alert: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AuthAlert
